import * as React from 'react';

import { DictionaryItem } from '../../../typings/common';
import { ExtendedTagValue, TagInputType } from '../../../typings/tagCloudTargeting';
import { TextInputDecorator } from '../../TextInputDecorator/TextInputDecorator';
import { Tag } from '../Tag/Tag';
import { TagEditor } from '../TagEditor/TagEditor';

export interface EditableTagProps {
    tag: ExtendedTagValue;
    inputType?: TagInputType;
    index: number;
    isOpenForEdit: boolean;
    showUserValueOnEdit?: boolean;
    prefix?: string;
    suggestItems?: DictionaryItem[];
    onSubmit: (value: string[]) => void;
    onFocus?: () => void;
    onBlur?: () => void;
    onDelete: (index: number) => void;
    onClick: (index: number) => void;
    onCancel: () => void;
    onRefChange?: (ref: React.RefObject<TextInputDecorator>) => void;
}

export const EditableTag: React.FC<EditableTagProps> = React.memo(props => {
    const {
        tag,
        index,
        isOpenForEdit,
        showUserValueOnEdit,
        inputType,
        prefix,
        suggestItems,
        onBlur,
        onFocus,
        onSubmit,
        onDelete,
        onClick,
        onCancel,
        onRefChange
    } = props;

    if (isOpenForEdit) {
        const tagValue = showUserValueOnEdit && tag.renderValue ? tag.renderValue : tag.value;

        return (
            <TagEditor
                tagValue={tagValue}
                suggestItems={suggestItems}
                inputType={inputType}
                index={index}
                onFocus={onFocus}
                onBlur={onBlur}
                onSubmit={onSubmit}
                onCancel={onCancel}
                onRefChange={onRefChange}
                onDelete={onDelete}
            />
        );
    }

    return <Tag tagValue={tag} index={index} prefix={prefix} onClick={onClick} onDelete={onDelete} />;
});
